import { useFormikContext } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LaunchpadCard } from 'src/components/ui/LaunchpadCard';
import { isSmallMobileDeviceQuery } from 'src/util/responsive';
import { number, object, string } from 'yup';
import { useMediaQuery } from '@mui/material';
import { TAssetInvestmentDetailsSchema } from '@brickwise/asset-validation/dist/asset/investmentData';
import { RepaymentAmount } from './RepaymentAmount';
import { SecurityTypeSelector } from '../atomic-components/SecurityTypeSelector';
import { TerminationRightSelector } from '../atomic-components/TerminationRightSelector';
import { TerminationRightFrequencySelector } from '../atomic-components/TerminationRightFrequencySelector';
import { MaturityCheckbox } from '../atomic-components/MaturityCheckbox';
import { MaturityDatePicker } from '../atomic-components/MaturityDatePicker';
import { MaturityDateOnlyExpectedTerminationRightCheckbox } from '../atomic-components/MaturityDateOnlyExpectedTerminationRightCheckbox';
import { TaxInformationTextField } from '../atomic-components/TaxInformationTextField';
import { ForumCheckbox } from '../atomic-components/ForumCheckbox';
import { AssetTypeConditional } from '../../user/AssetTypeConditional';

export const validationSchemaSecurityTypeDetails = object({
  securityType: string(),
  terminationRight: string(),
  maturity: number(),
  terminationRightFrequency: string(),
  maturityDate: string(),
});

interface Props {
  disabled: boolean;
}

export const SecurityTypeDetails: FC<Props> = ({ disabled }) => {
  const formik = useFormikContext<TAssetInvestmentDetailsSchema>();
  const { t } = useTranslation();
  const isSmallMobileDevice = useMediaQuery(isSmallMobileDeviceQuery);

  return (
    <LaunchpadCard title={t('dashboard.assets.addedit.investment.securitytype.title')}>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: isSmallMobileDevice ? '1fr' : '1fr 1fr',
          columnGap: isSmallMobileDevice ? 'unset' : '24px',
        }}
      >
        <div>
          <SecurityTypeSelector disabled={disabled} />
          <AssetTypeConditional supported={['builderOwnerModel']}>
            <ForumCheckbox />
          </AssetTypeConditional>
        </div>
        <AssetTypeConditional supported={['realEstate', 'powerplant', 'powerplantPortfolio', 'citizenParticipationLoan', 'plot']}>
          <TerminationRightSelector disabled={disabled} />
        </AssetTypeConditional>
        <TaxInformationTextField disabled={false} />
        <AssetTypeConditional supported={['realEstate', 'powerplant', 'powerplantPortfolio', 'plot']}>
          <div>
            <TerminationRightFrequencySelector disabled={disabled} />
            <ForumCheckbox />
            <MaturityCheckbox />
          </div>
          {formik.values.investmentDetails?.maturity === true && (
            <>
              <MaturityDatePicker />
              <RepaymentAmount disabled={disabled} />
            </>
          )}
          <MaturityDateOnlyExpectedTerminationRightCheckbox disabled={disabled} />
        </AssetTypeConditional>

        <AssetTypeConditional supported={['citizenParticipationLoan']}>
          <MaturityDatePicker />
        </AssetTypeConditional>

      </div>
    </LaunchpadCard>
  );
};
